import { render, staticRenderFns } from "./AddAssetPoolDistribution.vue?vue&type=template&id=2e933238&"
import script from "./AddAssetPoolDistribution.vue?vue&type=script&lang=js&"
export * from "./AddAssetPoolDistribution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports